import React from "react";
import reactDOM from "react-dom";
import App from "./routes/App";
import { ChakraProvider } from "@chakra-ui/react";
import { Provider } from 'react-redux';
import store from './store';
import "./index.css";

reactDOM.render(
  <div>
    <Provider store={store}>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </Provider>
  </div>,
  document.getElementById("root")
);